module.exports = __webpack_public_path__ + "img/fbt-iocn01.a49529b1.svg";